import styled from 'styled-components';
import React from 'react';

import { Divider } from '@/features/course/admin/molecules/CourseSettingsModalForm/CourseSettingsModalForm';
import { RichTextDisplayer } from '@/ui/RichTextDisplayer';
import { LiveEventDateBlock } from '@/pages/LiveEvent/LiveEventDateBlock';
import { LiveEventLink } from '@/pages/LiveEvent/LiveEventLink';
import { LiveEvent } from '@/pages/LiveEvent/store/liveEvent/types';
import { LiveEventRecordingSection } from '@/pages/LiveEvent/LiveEventRecordingSection';
import { useLiveEventLocations } from '@/pages/LiveEvent/LiveEventLocationsContext';
import { RLocationType } from '@/store/v2';

type LiveEventDescriptionProps = Pick<LiveEvent, 'id' | 'title' | 'teaser' | 'progress' | 'completedAt'>;

const CommonTitle = styled.h3`
  margin-bottom: 24px;
  ${({ theme }) => theme.typography.title3};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const StyledDivider = styled(Divider)`
  width: 100%;
  margin: 32px 0;
`;

export const LiveEventDescription = ({ teaser, progress, completedAt }: LiveEventDescriptionProps): JSX.Element => {
  const { activeLocation } = useLiveEventLocations();

  return (
    <>
      <LiveEventDateBlock />
      <StyledDivider />
      <CommonTitle>{activeLocation?.type === RLocationType.Online ? 'Link to join' : 'Location'}</CommonTitle>
      <LiveEventLink
        address={activeLocation?.address}
        isOnline={activeLocation?.type === RLocationType.Online}
        linkMaxWidth="clamp(300px, 30vw, 640px)"
      />
      {!!teaser && (
        <>
          <StyledDivider />
          <CommonTitle>Event description</CommonTitle>
          <RichTextDisplayer content={teaser} />
        </>
      )}

      {activeLocation?.hasEnded && activeLocation?.recordingURL && (
        <>
          <StyledDivider />
          <LiveEventRecordingSection
            recordingURL={activeLocation?.recordingURL}
            hasEnded={activeLocation?.hasEnded}
            progress={progress}
            registration={activeLocation?.registration}
            completedAt={completedAt}
          />
        </>
      )}
    </>
  );
};
